/**
 * Survey turned off — renders nothing everywhere.
 * Kept as a no-op so existing imports/usages don't break.
 */
export default function SurveyTrigger() {
  return null;
}